import { createReducer, on } from '@ngrx/store';
import * as GroupPermissionsActions from '../actions/group-permissions.actions';
import { EmployeeGroupPermission } from '@fc-core';

export const groupPermissionsFeatureKey = 'groupPermissions';

export interface State {
  currentPermissions: EmployeeGroupPermission[];
  loading: boolean;
  error: any;
}

export const initialState: State = {
  currentPermissions: [],
  loading: false,
  error: null,
};

export const reducer = createReducer(
  initialState,

  on(GroupPermissionsActions.loadGroupPermissions, (state) => ({
    ...state,
    loading: true,
    currentPermissions: [] as EmployeeGroupPermission[],
  })),
  on(GroupPermissionsActions.loadGroupPermissionsSuccess, (state, action) => ({
    ...state,
    loading: false,
    currentPermissions: action.data,
  })),
  on(GroupPermissionsActions.loadGroupPermissionsFailure, (state, action) => ({
    ...state,
    loading: false,
    error: action.error,
  })),
  on(GroupPermissionsActions.removeGroupPermissionSuccess, (state, action) => ({
    ...state,
    loading: false,
    currentPermissions: state.currentPermissions.map((permission) =>
      permission.id === action.permissionId
        ? {
            ...permission,
            isSelected: false,
          }
        : permission,
    ),
  })),
  on(GroupPermissionsActions.addGroupPermissionSuccess, (state, action) => ({
    ...state,
    loading: false,
    currentPermissions: state.currentPermissions.map((permission) =>
      permission.id === action.permissionId
        ? {
            ...permission,
            isSelected: true,
          }
        : permission,
    ),
  })),
);

export const getCurrentPermissions = (state: State) => state.currentPermissions;
export const getLoading = (state: State) => state.loading;
export const getError = (state: State) => state.error;
